$(document).foundation();
$(document).ready( function () {

	patternlib();
	initSliders();
	initCarousels();
	initHeader();
	initOffCanvas();
	initToggleInView();
	inlineSVGs('.footer-social-nav img');
	initHistoryPage();
	initOffersGrid();
	initForms();
	initPopupVideos();
	initGallery();
	initRTL();
	initCapacityTables();
	// initReviewsWidget();
	//initVerticalCenter();
	initAccordions();
	initGridBlockFilters();
	initLocationMap();
	checkDirectionsRadio();
	swapOriginAndDestination();
	clearDirections();
	initBookDirectPopup();
	initCookiePopup();
	initCornerPopup();
});

$("a#inline").fancybox({
		'hideOnContentClick': true
	});

function swapOriginAndDestination() {
	var originToDest = '';
	var destToOrigin = '';
	$('.swap-button').on('click', function() {
		originToDest = $('input.origin').val();
		destToOrigin = $('input.destination').val();
		$('input.origin').val(destToOrigin);
		$('input.destination').val(originToDest);

		if ( ($('input.origin').val() !== '') && ($('input.destination').val() !== '') ) {
			$('form input[type="submit"]').trigger('click');
		}
	});
}

function clearDirections() {
	$('.clear-button').on('click', function() {
		if ( $('#map-directions-data').children() !== null ) {
			$('#map-directions-data').children().remove();
			initMaps();
		}
	});
}

function checkDirectionsRadio() {
	$('.mode-select label').on('click', function() {
		if ( $(this).hasClass('checked') ) {
			return
		} else {
			$('.mode-select .checked').removeClass('checked');
			$('.mode-select input[type="radio"]:checked').prop("checked", false);
			$(this).addClass('checked');
			$(this).siblings('[name="jeff"]').prop('checked', true);

			if ( ($('input.origin').val() !== '') && ($('input.destination').val() !== '') ) {
				$('form input[type="submit"]').trigger('click');
			}
		}
	});
}

function initLocationMap() {
	if ($('.location-map-image').length > 0) {
		$('.location-map-image map').imageMapResize();

		$('.location-map-panel-close').on('click', function () {
			$(this).parent().removeClass('open');
		});

		$('.location-map-image .map-links a').on('click', function () {
			$('.location-map-panel.open').removeClass('open');
			$($(this).attr('href')).addClass('open');
			return false;
		});


		$('.location-map-panel .right-arrow').on('click', function () {
			$(this).parent().parent().parent().parent().removeClass('open');
			$(this).parent().parent().parent().parent().next().addClass('open');
			return false;
		});

		$('.location-map-panel .left-arrow').on('click', function () {
			$(this).parent().parent().parent().parent().removeClass('open');
			$(this).parent().parent().parent().parent().prev().addClass('open');
			return false;
		});



		$(".info-row-large .location-info").css({ 'height': ($(".info-row-large .info-image").height() + 'px') });


	}
}

function initGridBlockFilters() {
	if ($('.filter-button').length === 0) {
        // nothing to filter
        return;
    }

    var filterItems = $('[data-filter-categories]');

    var triggerReflow = function () {
        // get current block size
        var blockSize;

        switch (Foundation.MediaQuery.current) {
        	case 'small':
        	blockSize = 1;
        	break;
        	case 'medium':
        	case 'large':
        	case 'xlarge':
        	blockSize = 2;
        	break;
        	case 'xxlarge':
        	blockSize = 3;
        	break;
        }

        // update clear settings on visible blocks
        filterItems.css('clear', 'none');
        filterItems
        .not(':hidden')
        .filter(function (i) {
        	return i % blockSize == 0;
        })
        .css('clear', 'both');
    };

    $('.filter-button').on('click', function (e) {
    	var selectedCategory = $(this).data('filter-category');

    	$(this)
    	.siblings('.filter-button')
    	.removeClass('filter-button--active');

    	$(this).addClass('filter-button--active');

        // only show elements with selected category
        filterItems
        .fadeOut()
        .promise()
        .done(function () {
        	filterItems
        	.each(function () {
        		if ($(this).is('[data-filter-categories~="' + selectedCategory + '"]')) {
        			$(this).fadeIn();
        		}
        	})
        	.promise()
        	.done(triggerReflow);
        });

        e.preventDefault();
    });
}


function initAccordions() {
	$('.accordion').accordiom({
		showFirstItem: false
	});

	$('.accordionButton').each( function() {
		if ( $(this).next('.accordionContent').children().length <= 0 ) {
			//$(this).css("background", "none");
			$(this).addClass('no-accordionContent');
		}
	})
}


function initVerticalCenter() {
	$('.vertical-center').each(function () {
		$(this).wrapInner('<div class="vertical-center-table"><div class="vertical-center-row"><div class="vertical-center-cell"></div></div></div>');
	});
}


function initSliders() {

	if ($('.full-page-slider')[0]) { // add padding if no slider

	} else {
		$('main').css('padding-top', '165px');
	}


	if ( $('.full-page-slider, .full-page-video').length > 0 ) {

		setSliderHeight();
		$(window).on('resize', setSliderHeight);

		function setSliderHeight() {
			if ( window.innerWidth > 640 ) { // Mobile + Desktop
				$(':not(.shorter) > .full-page-slider-inner, .full-page-video').css('height', window.innerHeight).css('top', '0');
				if ( $('.shorter').length === 0 ) {
					$('main').css('padding-top', '35px');
				}
			} else { // Tablet
				$(':not(.shorter) > .full-page-slider-inner, .full-page-video').css('height', window.innerHeight - 100).css('top', '0');
				if ( $('.shorter').length === 0 ) {
					$('main').css('padding-top', '135px');
				}
			}
		}

		if ( $('.full-page-video iframe, .full-page-video video').length > 0 ) {
			isAutoplaySupported(function(supported) {
				if ( (supported) && (window.navigator.userAgent.indexOf('iPad') < 0) ) {
					$('.video-loading').fadeOut();
					/*var player = new Vimeo.Player($('.full-page-video iframe')[0]);
					player.on('play', function() {
						setTimeout( function () {
							$('.video-loading').fadeOut();
						}, 2000);
						setTimeout( function () {
							$('.full-page-video iframe').addClass('playing'); // keep the video hidden and only show after playing starts
						}, 200);
		    		});
					player.on('ended', hideVideo);
		    		$('.skip-video').on('click', hideVideo);
		    		*/

		    		if ( !$('.full-page-video video')[0].paused ) { // Video already playing?
		    			console.log('Video already playing');
		    			$('.video-loading').fadeOut();
		    			$('.full-page-video video').addClass('playing');
		    		} else {
			    		$('.full-page-video video').on('play', function () { // no, so add event and wait for it to start
			    			console.log('Video play event triggered');
			    			setTimeout( function () {
			    				$('.video-loading').fadeOut();
			    			}, 100);
			    			setTimeout( function () {
								$('.full-page-video video').addClass('playing'); // keep the video hidden and only show after playing starts
							}, 200);
			    		});
			    	}

			    	$('.full-page-video video').on('ended', hideVideo);
			    	$('.skip-video').on('click', hideVideo);
			    	$('.full-page-video video').prop('muted', !$('.full-page-video video').prop('muted'));
			    	$('.mute-video').on('click', function () {
			    		$('.full-page-video video').prop('muted', !$('.full-page-video video').prop('muted'));
			    		if ($(this).text() == $(this).data('mute-text')) {
			    			$(this).text($(this).data('unmute-text'));
			    		} else {
			    			$(this).text($(this).data('mute-text'));
			    		}
			    	});

			    	scaleVideo();
			    	$(window).on('resize', scaleVideo);
			    } else {
			    	hideVideo();
			    }
			});
		} else {
			$('.full-page-slider-inner').reformSlider({
				speed: 6000,
				animationSpeed: 1000,
				arrows: true,
				pagination: false,
				paginationArrows: true
				// onLoad: fadeOutCaption,
				// afterChange: fadeOutCaption
			});
		}

	}





	$('.full-page-slider-scroll button').on('click', function () {
		$('html, body').animate({
			scrollTop: $('.full-page-slider').outerHeight()
		}, 750);
	});




	$('.short-slider-inner').reformSlider({
		speed: 6000,
		animationSpeed: 1000,
		arrows: false,
		pagination: true,
		paginationArrows: true
	});


	$('.landing-carousel').slick({
		arrows:true,
		infinite: false
	});


	$('.landing-carousel').slick("setPosition");

	$('.detail-photo-carousel').slick({
		infinite: false,
		arrows: true
	});

	$('.landing-item-image').slick({
		infinite: true,
		arrows: false,
		dots: true,
		autoplay: true,
		autoplaySpeed: 4000
	});




}


function hideVideo() {
	$('.full-page-video').fadeOut(function () {
		$('.full-page-video video')[0].pause();
	});

	$('.full-page-slider-inner').reformSlider({
		speed: 6000,
		animationSpeed: 1000,
		arrows: false,
		pagination: true,
		paginationArrows: true
		// onLoad: fadeOutCaption,
		// afterChange: fadeOutCaption
	});
}


// https://gist.github.com/nathansearles/271870d4100f0f045c5c
// isAutoplaySupported(callback);
// Test if HTML5 video autoplay is supported
isAutoplaySupported = function(callback) {
  // Is the callback a function?
  if (typeof callback !== 'function') {
  	console.log('isAutoplaySupported: Callback must be a function!');
  	return false;
  }
  // Check if sessionStorage exist for autoplaySupported,
  // if so we don't need to check for support again
  if (!sessionStorage.autoplaySupported) {
    // Create video element to test autoplay
    var video = document.createElement('video');
    video.autoplay = true;
    video.muted = true;
    video.src = 'data:video/mp4;base64,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';
    video.load();
    video.style.display = 'none';
    video.playing = false;
    video.play();
    // Check if video plays
    video.onplay = function() {
    	this.playing = true;
    };
    // Video has loaded, check autoplay support
    video.oncanplay = function() {
    	if (video.playing) {
    		sessionStorage.autoplaySupported = 'true';
    		callback(true);
    	} else {
    		sessionStorage.autoplaySupported = 'false';
    		callback(false);
    	}
    };
} else {
    // We've already tested for support
    // use sessionStorage.autoplaySupported
    if (sessionStorage.autoplaySupported === 'true') {
    	callback(true);
    } else {
    	callback(false);
    }
}
}

// Usage: isAutoplaySupported(callback);
// Using a callback assures that support
// has been properly checked
isAutoplaySupported(function(supported) {
	if (supported) {
    // HTML5 Video Autoplay Supported!
    console.log('HTML5 Video Autoplay Supported!');
} else {
    // HTML5 Video Autoplay Not Supported :(
    console.log('HTML5 Video Autoplay Not Supported :(');
}
});


// Fade out the caption text just before the slide changes
function fadeOutCaption() {
	setTimeout(function () {
		$('.reform-slide-current .video-caption-wrapper').fadeOut(1500);
		$('.reform-slide:not(.reform-slide-current) .video-caption-wrapper').fadeIn();
	}, 2000);
}


function scaleVideo() {
	var viewportWidth = $(window).innerWidth();
	var viewportHeight = $(window).innerHeight();

	var $videoElement;
	if ( $('.full-page-slider iframe').length > 0 ) {
		$videoElement = $('.full-page-slider iframe');
	} else if ( $('.full-page-video video').length > 0 ) {
		$videoElement = $('.full-page-video video');
	} else {
		return;
	}

	var videoWidth = $videoElement.attr('width');
	var videoHeight = $videoElement.attr('height');

	// Aspect ratio = height / width
	var viewportRatio = viewportHeight / viewportWidth;
	var videoRatio = videoHeight / videoWidth;

	//console.log('Viewport: ', viewportRatio, ' Video: ', videoRatio);


	var newWidth = (videoWidth / videoHeight) * viewportHeight
	var newHeight = (videoHeight / videoWidth) * viewportWidth;
	var newTop = 0;

	if (viewportRatio > videoRatio) {
		// set video height to the viewport, and extend the video beyond the viewport width, i.e. portrait viewport
		//console.log('crop left and right');
		$videoElement.css('height', viewportHeight);
		$videoElement.css('width', newWidth);
		$videoElement.css('left', '-' + (newWidth - viewportWidth) / 2 + 'px');
		$videoElement.css('top', '0');
	} else if (viewportRatio < videoRatio) {
		// set video width to the viewport, and extend the video beyond the viewport height, i.e. landscape viewport
		//console.log('crop top and bottom');
		$videoElement.css('width', viewportWidth);
		$videoElement.css('height', newHeight);
		$videoElement.css('left', '0');
		$videoElement.css('top', '-' + (newHeight - viewportHeight) / 2 + 'px');
	} else {
		// set the video width AND height to the viewport size, i.e. viewport is the same ratio as the video
		//console.log('no crop');
		$videoElement.css('height', viewportHeight);
		$videoElement.css('width', viewportWidth);
		$videoElement.css('left', '0');
		$videoElement.css('top', '0');
	}
}


function initCarousels() {
	$('.detail-features-carousel').slick({
		infinite: false,
		arrows: true
	});


	$('.detail-related-carousel').slick({
		autoplay: true,
		autoplaySpeed: 6000,
		arrows: true,
		speed: 700,
		slidesToShow: 2,
		responsive: [
		{
			breakpoint: 640,
			settings: {
				slidesToShow: 1
			}
		}
		]
	});


	alignArrows();
	$(window).on('resize', alignArrows);


}


function alignArrows() {
	setTimeout(function () {
		// Carousel arrows
		$('.detail-related-carousel .slick-arrow').css('top', ($('.detail-related-carousel img').first().outerHeight() / 2 ) + 'px');
	}, 500);
}



function initHeader() {

	// Set the header background to transparent if it is displaying over the image slider
	updateHeaderColor();
	$(document).on('scroll', _.throttle(updateHeaderColor, 100));

	function updateHeaderColor() {
		if ( $(window).scrollTop() <= $('.full-page-slider, .short-slider').outerHeight() / 4 ) {
			$('body').addClass('transparent-header');
		} else {
			$('body').removeClass('transparent-header');
		}
	}

}



function initOffCanvas() {

	// Align the burger menu sub items
	var longestNavItem = 0;
	$('.primary-nav > ul > li > a').each( function () {
		if ( $(this).outerWidth() > longestNavItem ) {
			longestNavItem = $(this).outerWidth();
		}
	});
	longestNavItem += 20;
	$('.off-canvas-primary-sub').css('left', longestNavItem + 'px');


	// Allow touch devices to see the subpages of a section
	$('.primary-nav > ul > li > a').on('click', function () {
		if ( $('html').hasClass('whatinput-types-touch') ) {
			if ( $(this).parent().hasClass('visible') ) {
				return true;
			} else {
				$('.primary-nav li.visible').removeClass('visible');
				$(this).parent().addClass('visible');
				return false;
			}
		}
	});

}


function initToggleInView() {

	if ($('[data-toggle-in-view]').length === 0) {
		// nothing to toggle
		return;
	}

	$(window).on('scroll.toggle-in-view', function (e) {
		var screenBottom = $(window).scrollTop() + window.innerHeight;

		$('[data-toggle-in-view]').each(function (i, el) {
			var elem = $(el);

			if ((elem.offset().top + 100) > screenBottom) {
				// element not in view yet
				return;
			}

			// toggle class
			elem.addClass(elem.data('toggle-in-view'));

			// remove attribute
			elem.removeAttr('data-toggle-in-view');
		});

		if ($('[data-toggle-in-view]').length === 0) {
			// all elements visible, remove scroll event handler
			$(window).off('scroll.toggle-in-view');
		}
	});

};



// https://stackoverflow.com/questions/24933430/img-src-svg-changing-the-fill-color
function inlineSVGs(selectorString) {

	$(selectorString).each(function(){
		var $img = $(this);
		var imgID = $img.attr('id');
		var imgClass = $img.attr('class');
		var imgURL = $img.attr('src');

		if (imgURL.indexOf('.svg') < 0) {
			return;
		}

		$.get(imgURL, function(data) {
	        // Get the SVG tag, ignore the rest
	        var $svg = $(data).find('svg');

	        // Add replaced image's ID to the new SVG
	        if(typeof imgID !== 'undefined') {
	        	$svg = $svg.attr('id', imgID);
	        }
	        // Add replaced image's classes to the new SVG
	        if(typeof imgClass !== 'undefined') {
	        	$svg = $svg.attr('class', imgClass+' replaced-svg');
	        }

	        // Remove any invalid XML tags as per http://validator.w3.org
	        $svg = $svg.removeAttr('xmlns:a');

	        // Check if the viewport is set, if the viewport is not set the SVG wont't scale.
	        if(!$svg.attr('viewBox') && $svg.attr('height') && $svg.attr('width')) {
	        	$svg.attr('viewBox', '0 0 ' + $svg.attr('height') + ' ' + $svg.attr('width'))
	        }

	        // Replace image with new SVG
	        $img.replaceWith($svg);

	    }, 'xml');

	});

}




function initHistoryPage() {
	$('.history-item-image-zoom').on('click', function () {
		$(this).parent().toggleClass('zoomed');
	});
}





function initOffersGrid() {
	$('.offers-grid-item:odd').not(':last').after('<div class="offers-grid-divider"></div>');
}




function initForms() {
	$('.contact-form form').validate();
	$('.off-canvas-newsletter form').validate();
}




// function initLocationMap() {
// 	if ($('.location-map-image').length > 0) {
// 		$('.location-map-image map').imageMapResize();

// 		$('.location-map-panel-close').on('click', function () {
// 			$(this).parent().parent().parent().removeClass('open');
// 		});

// 		$('.location-map-image area').on('click', function () {
// 			$('.location-map-panel.open').removeClass('open');
// 			$($(this).attr('href')).addClass('open');
// 			return false;
// 		});
// 	}
// }



function initPopupVideos() {
	$('a[href*="player.vimeo.com"]').fancybox({
		type: 'iframe',
		padding: 30,
		wrapCSS: 'popup-video'
	});
}



function initGallery() {
	$('.gallery-carousel').slick({
		slidesToShow: 4,
		arrow: true,
		responsive: [
		{
			breakpoint: 640,
			settings: {
				slidesToShow: 2
			}
		}
		]
	});

	$('.gallery-carousel a').fancybox({
		type: 'ajax',
		padding: [0, 30, 0, 30],
		wrapCSS: 'gallery-popup',
		autoHeight: true
	});
}



function initRTL() {

	if ( window.location.href.indexOf('/ar/') > -1 ) {
		$('body').addClass('rtl');
	}

}




function initCapacityTables() {

	$('.tcell.popups a').fancybox({
		type: 'ajax',
		padding: [0, 30, 0, 30],
		wrapCSS: 'gallery-popup',
		autoHeight: true
	});

	$('#feet, #mtr').on('click', function () {
		if ( !$(this).hasClass('active') ) {
			return; // halt if this is already selected
		}

		$('#feet, #mtr').toggleClass('active');

		if ( $(this).attr('id') === 'feet' ) { // convert meters to feet
			$('#areaUnits').text('Ft');
			$('.dimension').each( function () {
				$(this).text( parseFloat(parseFloat($(this).text()) * 3.2808).toFixed(2) );
			});
			$('.areadimension').each( function () {
				$(this).text( parseFloat(parseFloat($(this).text()) / 0.09290304).toFixed(2) );
			});
		} else if ( $(this).attr('id') === 'mtr' ) { // convert feet to meters
			$('#areaUnits').text('M');
			$('.dimension').each( function () {
				$(this).text( parseFloat(parseFloat($(this).text()) / 3.2808).toFixed(2) );
			});
			$('.areadimension').each( function () {
				$(this).text( parseFloat(parseFloat($(this).text()) * 0.09290304).toFixed(2) );
			});
		}
	});

}




// function initReviewsWidget() {
// 	var configData = '{"staging":false,"apiKeyStg":"ouw9v7k5ehuldslskw3yi9jgj","apiKey":"t7glodpixu3faifbjkpp0y8c9","moderatorhighlights":false,"productId":"PRGHA","layoutType":"vert","brandSelector":"ic","bLanguage":"en","languageCode":"en","countryCode":"1","domain":"ihg.com/intercontinental","layoutWidth":"150px","languageLabelsData":{"header":"Guest Reviews","bbody":"({{1}} Reviews by Real Guests)","readreviews":"READ REVIEWS"},"BVFRWStyles":"#IWSfrContainer {padding: 5px 10px 10px; border: 1px solid #cccccc; background: #F9FAF7;}.IWSfrHeader {padding: 5px 0;}.IWSfrLink a {height: auto; font-size: 11px; text-transform: uppercase;}.IWSfrContainer_vert .IWSfrLink a {display: block; height: auto; font-size: 11px; text-transform: uppercase;}.IWSfrContainer_ar {text-align: right;}.IWSfrContainer_vert .IWSfrContainer_de .IWSfrHeader, .IWSfrContainer_vert .IWSfrContainer_nl .IWSfrHeader, .IWSfrContainer_vert .IWSfrContainer_tr .IWSfrHeader {font-size: 14px;}.IWSfrContainer_horiz {position: relative; padding-bottom: 5px !important;}.IWSfrContainer_horiz .IWSfrLogo {float: left; margin-right: 5px;}.IWSfrContainer_horiz .IWSfrHeader {padding: 0; line-height: 1;}.IWSfrContainer_horiz .IWSfrLink {position: absolute;right: 10px; top: 0; margin: 0!important;}.IWSfrContainer_horiz .IWSfrCount {display: inline; padding-left: 7px;}","selectedBrandData":{"bFontFamily":"font-family:Times New Roman; text-transform:uppercase;","fullname":"intercontinental","hColor":"7b5400","headerHColor":"54534A","linkWeight":"bold","linkColor":"ffffff","borderRadius":"2px"},"stagingUrl":"//stg.api.bazaarvoice.com/data/reviews.json","productionUrl":"//api.bazaarvoice.com/data/reviews.json","additionalParameters":"","apiVersion":5.4,"limit":1,"noContentResponse":"No Data","bvContainerId":"IWSfrContainer","fontFace":"font-family:Times New Roman; text-transform:uppercase;"}';javascript:(function(e,a,g,h,f,c,b,d){if(!(f=e.jQuery)||g>f.fn.jquery||h(f)){c=a.createElement("script");c.type="text/javascript";c.src="https://ajax.googleapis.com/ajax/libs/jquery/"+g+"/jquery.min.js";c.onload=c.onreadystatechange=function(){if(!b&&(!(d=this.readyState)||d=="loaded"||d=="complete")){h((f=e.jQuery).noConflict(1),b=1);f(c).remove()}};a.documentElement.childNodes[0].appendChild(c)}})(window,document,"1.11.0",function($,L){
// 	// If these function is used on hotels/third-party website, render the widget as soon as page load.
// 	if(typeof configData !== 'undefined') {
// 		$(document).ready(function() { BVFRW.featuredReview( JSON.parse(configData) ); });
// 	}
// 	BVFRW = {
// 		featuredReview: function( bvc ) {
// 			if(!bvc.languageLabelsData || !bvc.selectedBrandData || bvc.layoutType === "") {
// 				$("#IWSfrContainer").empty();
// 				$("#generatedCodeBVFRWWidget").val("");
// 				return false;
// 			}
// 			bvc.stagingUrl = bvc.stagingUrl || '//stg.api.bazaarvoice.com/data/reviews.json';
// 			bvc.productionUrl = bvc.productionUrl || '//api.bazaarvoice.com/data/reviews.json';
// 			bvc.moderatorhighlights = bvc.moderatorhighlights || false;
// 			bvc.additionalParameters = (bvc.moderatorhighlights) ? '&attributes=ModeratorCodes,moderatorhighlights&filter=ModeratorCode:eq:PQ&callback=?' : '';
// 			bvc.apiVersion = bvc.apiVersion || 5.4;
// 			bvc.limit = bvc.limit || 1;
// 			bvc.noContentResponse = bvc.noContentResponse || 'No Data';
// 			bvc.bvContainerId = bvc.bvContainerId || 'IWSfrContainer'; /* container to place content into */
// 			bvc.fontFace = (bvc.selectedBrandData.bFontFamily) ? bvc.selectedBrandData.bFontFamily : 'color:#'+bvc.selectedBrandData.hColor;

// 			/* set staging or production values */
// 			var urlPath = (bvc.staging) ? bvc.stagingUrl : bvc.productionUrl;
// 			var apiKey = (bvc.staging) ? bvc.apiKeyStg : bvc.apiKey;
// 			/* build parameter string */
// 			var urlParams = '?apiversion='+bvc.apiVersion+'&passkey='+apiKey+'&include=products&stats=reviews&filter=ProductId:'+bvc.productId+'&limit='+bvc.limit+bvc.additionalParameters;
// 			var headerColor = (bvc.selectedBrandData.headerHColor) ? bvc.selectedBrandData.headerHColor : bvc.selectedBrandData.hColor;

// 			/* these are the template containers, the classes/ids should not change */
// 			var pQContents =  '<div class="IWSfrLogo"><img src=""/></div>';
// 			pQContents += '<div class="IWSfrContentContainer">';
// 			pQContents += '  <div class="IWSfrHeader" style="color:#'+bvc.selectedBrandData.hColor+';font-size:16px;clear:both;"></div>';
// 			pQContents += '  <div class="IWSfrOverall" style="font-size:11px;color:#444444;">';
// 			pQContents += '    <img src=""/>';
// 			pQContents += '    <span class="IWSfrOutOf"><span style="color:#'+bvc.selectedBrandData.hColor+';font-size:18px;"></span>/5</span>';
// 			pQContents += '    <div class="IWSfrCount"></div>';
// 			pQContents += '  </div>';
// 			pQContents += '  <div class="IWSfr"></div>';
// 			pQContents += '</div>';

// 			function getRatingSuccess(data) {
// 				if(!bvc.languageLabelsData || !bvc.selectedBrandData || bvc.layoutType === "") {
// 					$("#IWSfrContainer").empty();
// 					$("#generatedCodeBVFRWWidget").val("");
// 					return false;
// 				}
// 				$("#"+bvc.bvContainerId).empty();
// 				var brandNamePath = (bvc.selectedBrandData.alternativeBrandName) ? bvc.selectedBrandData.alternativeBrandName : bvc.brandSelector;
// 				var logoPath = 'https://www.ihg.com/content/dam/etc/media_library/branded/'+brandNamePath+'/common/brand-logos/'+bvc.layoutType+'/img_'+bvc.selectedBrandData.fullname+'.png';
// 				$("#"+bvc.bvContainerId).prepend(pQContents).css('width',bvc.layoutWidth); /* add container divs to dom */
// 				$('head').append('<style type="text/css" id="BVFRWStyles">'+bvc.BVFRWStyles+'</style>'); /* add css to page */
// 				$("#"+bvc.bvContainerId+' .'+'IWSfrLogo img').attr('src', logoPath)  add logo src
// 				$("#"+bvc.bvContainerId+' .'+'IWSfrHeader').html(bvc.languageLabelsData.header).attr('style',bvc.fontFace); /* set header language */

// 	            // Generate the "Read Review" widget button
// 	            /*
// 	            var hotelUrl = "//www." + bvc.domain + "/hotels/" + bvc.countryCode + "/" + bvc.languageCode + "/"
// 			                	+ bvc.productId.toLowerCase() + "/hoteldetail/hotel-reviews?cm_mmc=iws_widget_"
// 	                			+ bvc.productId.toUpperCase() + "&icdv=99502222";
// 	                			*/
// 	                			var brandSel = bvc.brandSelector;
// 	                			if(brandSel=='ihg'){
// 	                				brandSel='6c';
// 	                			}


// 	                			var regionSel = $("#languageCode option:selected").attr("data-country");

// 	                			var envVal="";

// 	                			if(location.host.indexOf("qap.")!=-1){
// 	                				envVal="qap."
// 	                			}else if(location.host.indexOf("staging.")!=-1){
// 	                				envVal="staging."
// 	                			}


// 	                			var hotelUrl = "//"+envVal+"www." + bvc.domain + "/redirect?path=hd-hotel-reviews"+
// 	                			"&brandCode="+brandSel+
// 	                			"&hotelCode="+bvc.productId.toLowerCase()+
// 	                			"&regionCode="+bvc.countryCode+
// 	                			"&localeCode="+bvc.languageCode+
// 	                			"&cm_mmc=iws_widget_"+ bvc.productId.toUpperCase() + "&icdv=99502222&dp=true";

// 	                			console.log("Hotel Review URL : " + hotelUrl);

// 	                			$("#IWSfrContainer").append('<div class="IWSfrLink"><a href=' + hotelUrl + ' target="_blank">'+bvc.languageLabelsData.readreviews+'</a></div>');

// 	                			$("#"+bvc.bvContainerId+' .'+'IWSfrLink a').css({ /* style button */
// 	                				'background-color' : '#'+headerColor,
// 	                				'color' : '#'+bvc.selectedBrandData.linkColor,
// 	                				'border' : '1px solid #'+bvc.selectedBrandData.headerHColor,
// 	                				'border-radius': bvc.selectedBrandData.borderRadius,
// 	                				'height' : 'auto',
// 	                				'font-weight' : bvc.selectedBrandData.linkWeight,
// 	                				'line-height' : '11px',
// 	                				'margin-top' : '5px',
// 	                				'padding' : '5px',
// 	                				'text-align' : 'center',
// 	                				'display' : 'inline-block',
// 	                				'text-decoration' : 'none'
// 	                			}).parent().css({
// 	                				'margin-top' : '10px'
// 	                			});

// 	                			if (data.HasErrors === true || !data.Results || data.Results.length === 0) { /* return errors (hidden) */
// 	                				$("#IWSfrContainer").empty();
// 	                				$("#IWSfrContainer").html("Unable to load hotel review ratings.");
// 	                				$("#generatedCodeBVFRWWidget").empty().val("");
// 	                // $("#"+bvc.bvContainerId+' .IWSfrContentContainer').attr('style', 'display: none;').html('<div class="custom-bv-text" style="display:none">API Response Error: ' + data.Errors[0].Message+ '<br/>API URL: ' + urlPath + urlParams+'</div>');
// 	                return false;

// 	            } else if ( data.TotalResults > 0 ) { /* does return review data */
// 	            	var reviewResults = data.Results[0];
// 	            	var reviewStats = data.Includes.Products[bvc.productId];
// 	            	var qPTotalReviewCount = reviewStats.TotalReviewCount;
// 	            	var ratingAveNumber = parseFloat(reviewStats.ReviewStatistics.AverageOverallRating).toFixed(1);
// 	            	var overAllStarPath = 'https://intercontinental.ugc.bazaarvoice.com/2067/'+ratingAveNumber.replace(/\./g, '_')+'/5/rating.gif';
// 	            	var selectedText = (reviewResults.ModeratorHighlights && bvc.moderatorhighlights)? reviewResults.ModeratorHighlights.PQ.Highlights[0].SelectedText : '';

// 	            	/* add data content to approprate containers */
// 	            	$("#"+bvc.bvContainerId).removeClass();
// 	            	$("#"+bvc.bvContainerId).addClass(bvc.bvContainerId+'_'+bvc.layoutType+' '+bvc.bvContainerId+'_'+bvc.bLanguage)
// 	            	$("#"+bvc.bvContainerId+' .'+'IWSfrOverall img').attr('src', overAllStarPath);
// 	            	$("#"+bvc.bvContainerId+' .'+'IWSfrOutOf span').html( ratingAveNumber );
// 	            	$("#"+bvc.bvContainerId+' .'+'IWSfrCount').html( bvc.languageLabelsData.bbody.replace(/\{\{1\}\}/g, reviewStats.TotalReviewCount)  );
// 	            	$("#"+bvc.bvContainerId+' .'+'IWSfr').html(selectedText);
// 	            	if((bvc.languageCode === 'ar' || bvc.languageCode === 'he') && bvc.layoutType === 'horiz') {
// 	            		$("div.IWSfrLink").css( "position", 'static');
// 	            	}

// 	            } else { /* hide overall container if no content */
// 	            	$("#"+bvc.bvContainerId+' .IWSfrContentContainer').attr('style', 'display: none;').html('<div class="custom-bv-text">' + bvc.noContentResponse + '</div>');
// 	            	return false;
// 	            }
// 	            // If it's RedirectLite website, generate the code which will be used on hotels/third-party website.
// 	            if($("#generatedCodeBVFRWWidget").length > 0) {
// 	            	$("#generatedCodeBVFRWWidget").val( "<div id='IWSfrContainer' "
// 	            		+ " style='font-family:Arial,Helvetica,sans-serif;'></div>"
// 	            		+ "<script type='text/javascript'>"
// 	            		+ "var configData = " + "'" +JSON.stringify(BVFRWConfig).trim() + "';"
// 	            		+ $("#widgetGeneratorFunctions").html().trim() + "<\/script>");
// 	            }
// 	        };

// 	        /* get product data */
// 	        $.getJSON(urlPath + urlParams, {
// 	        	format: 'json'
// 	        }).done(getRatingSuccess);
// 	    }
// 	}
// });
// }

$('a[href*="youtube.com/embed"]').fancybox({
	type: 'iframe',
	padding: [26, 34, 26, 34],
	helpers : {
		media: true
	},
	width       : 1200,
	height      : 675,
	aspectRatio : true
});



$("video").prop('muted', true);

$(".mute-video").click(function () {
	if ($("video").prop('muted')) {
		$("video").prop('muted', false);
        $(this).addClass('unmute-video'); // changing icon for button

    } else {
    	$("video").prop('muted', true);
        $(this).removeClass('unmute-video'); // changing icon for button
    }
    console.log($("video").prop('muted'))
});


if ( $( ".videoWrapper" ).length ) {

	$( "body" ).addClass('video-explore');

}



function initBookDirectPopup() {
	$('.header-book-direct-button').on('click', function () {
		$('.header-book-direct').addClass('open');
	});

	$('.header-book-direct-close').on('click', function () {
		$('.header-book-direct').removeClass('open');
	});
}

function initMoveContentDown() {
  var cookiePopupHeight = $('.cookie-popup').height();
  $('main').css('margin-top', cookiePopupHeight + "px");
}


function initCookiePopup() {

  if ($('.cookie-popup').length > 0) {
    var cookiePopupKeepHiddenFor = $('.cookie-popup').data('cookie-popup-keep-hidden-for-n-days') || 0

    if (!Cookies.get('hasSeenCookiePopup')) {
      $('.cookie-popup').css("display", "block");

	  initMoveContentDown();
	  $(window).on('resize', function() {
		  initMoveContentDown();
	  });

      if (cookiePopupKeepHiddenFor > 0) {
        Cookies.set('hasSeenCookiePopup', 'true', {expires: cookiePopupKeepHiddenFor});
      }
    }

    $( '.cookie-popup__cta' ).click(function() {
    // alert("hi");
		$('main').removeAttr('style');
    $('.cookie-popup').remove();

  });
  }
}


function initCornerPopup() {
	var popup = $(".corner-popup");

	if (popup.length === 0) return;
	var image = $(".corner-popup__img");
	var closeBtn = $('.corner-popup__close')
	var content = $(".corner-popup__content");
	var popupDelay = popup.data("popup-delay") || 0;
	var popupKeepHiddenFor = popup.data("popup-keep-hidden-for-n-days") || 0;

	if (Cookies.get("hasSeenPopup")) {
	popup.remove();
	return;
	}

	setTimeout(function () {
	popup.addClass("show");
	image.addClass("show");
	content.addClass("show");
	if (popupKeepHiddenFor > 0) {
		Cookies.set("hasSeenPopup", "true", { expires: popupKeepHiddenFor });
	}
	}, popupDelay);

	closeBtn.on('click', function () {
		popup.hide();
		popup.remove();
	})
}
